import { ActionDropdown } from '@ctw/shared/components/dropdown/action-dropdown';
import { type ClassName, tw, twx } from '@ctw/shared/utils/tailwind';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';

export type SortButtonProps<S extends string = string> = {
  className?: ClassName;
  defaultSort: S;
  onChange: (sort: S) => void;
  options: Array<S>;
};

export function SortButton<S extends string = string>({
  className,
  defaultSort,
  onChange,
  options,
}: SortButtonProps<S>) {
  const [selected, setSelected] = useState(defaultSort);

  return (
    <ActionDropdown
      className={tw`z-[600] max-h-[17.25rem] overflow-y-auto`}
      type="select"
      buttonClassName={twx(
        className,
        'w-min max-h-[17.25rem] rounded-md border border-divider-main bg-transparent p-0 shadow-sm',
      )}
      onItemSelect={(item) => {
        if (options.includes(item.key as S)) {
          onChange(item.key as S);
          setSelected(item.key as S);
        }
      }}
      items={options.map((option) => ({
        key: option,
        name: option,
        isSelected: selected === option,
      }))}
    >
      <div
        className={tw`flex items-center space-x-2 rounded-md border border-border-main border-transparent border-solid bg-white px-3 py-1 font-medium text-content-subtle text-sm capitalize shadow-sm hover:bg-background-hover`}
      >
        <span className={tw`whitespace-nowrap`}>
          Sort: <span className={tw`font-normal`}>{selected}</span>
        </span>
        <FontAwesomeIcon icon={faChevronDown} className={tw`ml-auto w-2`} />
      </div>
    </ActionDropdown>
  );
}
